import BaseComponent from 'foundation/base-component';
import { vodeNavEvents, vodNavModeTypes } from './enums';
import eventBus from 'general/js/event-bus';
import anime from 'animejs';

export default class VodNav extends BaseComponent {
    constructor(...args) {
        super(...args);

        this.activeNavLinkNode = null;
        this.currentContentNode = null;

        this.links = this.refs.links;
        this.content = this.refs.content;

        this.init();
    }

    init() {
        eventBus.addListener(vodeNavEvents.TOGGLE_TO_SEE_ALL, this.toggleView);
        this.tabsInit();
    }

    onDestroy() {
        eventBus.removeListener(vodeNavEvents.TOGGLE_TO_SEE_ALL, this.toggleView);
    }

    tabsInit() {
        Object.keys(this.links).forEach((key) => {
            const link = this.links[key];
            this.addListener(link, 'click', this.onLinkClick.bind(this, key));

            if (link.classList.contains('is-active')) {
                if (!this.activeNavLinkNode) {
                    this.activeNavLinkNode = link;

                    if (this.content[key]) {
                        this.content[key].classList.add('is-active');
                        this.currentContentNode = this.content[key];
                    }
                } else {
                    // remove dublicate state if found
                    link.classList.remove('is-active');
                }
            }
        });
    }

    toggleView = (props) => {
        if (props.mode === vodNavModeTypes.VOD) {
            anime({
                targets: document.documentElement,
                scrollTop: 0,
                duration: 400,
                easing: 'easeOutQuad'
            });

            this.showContent(this.content[props.key]);
        }
    }

    onLinkClick(key, e) {
        e.preventDefault();

        if (this.activeNavLinkNode) {
            this.activeNavLinkNode.classList.remove('is-active');
        }

        this.activeNavLinkNode = e.target;
        this.activeNavLinkNode.classList.add('is-active');
        this.showContent(this.content[key]);
    }

    showContent(contentNode) {
        if (this.currentContentNode) {
            if (this.currentContentNode === contentNode) {
                return;
            }

            this.currentContentNode.classList.remove('is-active');
        }

        contentNode.classList.add('is-active');
        this.currentContentNode = contentNode;
    }
}
